__turbopack_context__.v({
  "buttonWrapper": "style-module-scss-module__jdmXYq__buttonWrapper",
  "caseLink": "style-module-scss-module__jdmXYq__caseLink",
  "caseLinkDesktop": "style-module-scss-module__jdmXYq__caseLinkDesktop",
  "caseLinkMobile": "style-module-scss-module__jdmXYq__caseLinkMobile",
  "caseLinkOutline": "style-module-scss-module__jdmXYq__caseLinkOutline",
  "caseLinkText": "style-module-scss-module__jdmXYq__caseLinkText",
  "content": "style-module-scss-module__jdmXYq__content",
  "contentIndustry": "style-module-scss-module__jdmXYq__contentIndustry",
  "description": "style-module-scss-module__jdmXYq__description",
  "header": "style-module-scss-module__jdmXYq__header",
  "image": "style-module-scss-module__jdmXYq__image",
  "industry": "style-module-scss-module__jdmXYq__industry",
  "mainIndustryText": "style-module-scss-module__jdmXYq__mainIndustryText",
  "mainText": "style-module-scss-module__jdmXYq__mainText",
  "mediaWrapper": "style-module-scss-module__jdmXYq__mediaWrapper",
  "mobileLinksWrapper": "style-module-scss-module__jdmXYq__mobileLinksWrapper",
  "navigationEntrance": "style-module-scss-module__jdmXYq__navigationEntrance",
  "resultItem": "style-module-scss-module__jdmXYq__resultItem",
  "resultItemNumericTitle": "style-module-scss-module__jdmXYq__resultItemNumericTitle",
  "resultItemText": "style-module-scss-module__jdmXYq__resultItemText",
  "resultItemTextIndustry": "style-module-scss-module__jdmXYq__resultItemTextIndustry",
  "resultItemTitle": "style-module-scss-module__jdmXYq__resultItemTitle",
  "resultItemTitleIndustry": "style-module-scss-module__jdmXYq__resultItemTitleIndustry",
  "resultsList": "style-module-scss-module__jdmXYq__resultsList",
  "resultsListIndustry": "style-module-scss-module__jdmXYq__resultsListIndustry",
  "resultsWrapper": "style-module-scss-module__jdmXYq__resultsWrapper",
  "section": "style-module-scss-module__jdmXYq__section",
  "slidesCounter": "style-module-scss-module__jdmXYq__slidesCounter",
  "title": "style-module-scss-module__jdmXYq__title",
  "video": "style-module-scss-module__jdmXYq__video",
});
